import { render, staticRenderFns } from "./ycfd.vue?vue&type=template&id=f225289a&scoped=true&"
import script from "./ycfd.vue?vue&type=script&lang=js&"
export * from "./ycfd.vue?vue&type=script&lang=js&"
import style0 from "./ycfd.vue?vue&type=style&index=0&id=f225289a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f225289a",
  null
  
)

export default component.exports